// Sonave – visible difference: reveals the lenses when they scroll into view and
// counts the numbers up once their row is visible.
if (!customElements.get('glow-proof')) {
  customElements.define(
    'glow-proof',
    class GlowProof extends HTMLElement {
      connectedCallback() {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const designMode = Boolean(window.Shopify && window.Shopify.designMode);
        const stats = this.querySelector('.glow-proof__stats');
        const format = new Intl.NumberFormat(document.documentElement.lang || undefined);

        this.querySelectorAll('[data-count]').forEach((el) => {
          const n = parseFloat(el.dataset.count);
          if (!isNaN(n)) el.textContent = format.format(n);
        });

        if (!('IntersectionObserver' in window) || reduceMotion || designMode) {
          this.classList.add('is-revealed');
          if (stats) stats.classList.add('is-revealed');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-revealed');
              if (entry.target === stats) this.countUp(stats, format);
              this.observer.unobserve(entry.target);
            });
          },
          // reveal as soon as the section edges into view: a 25 % threshold made the tall
          // phone layout look empty for a long scroll
          { threshold: 0, rootMargin: '0px 0px -12% 0px' }
        );
        this.observer.observe(this);
        if (stats) this.observer.observe(stats);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      countUp(root, format) {
        root.querySelectorAll('[data-count]').forEach((el, i) => {
          const target = parseFloat(el.dataset.count);
          if (isNaN(target) || target <= 0) return;
          const duration = 1400 + i * 150;
          const start = performance.now();
          const tick = (now) => {
            const t = Math.min(1, (now - start) / duration);
            const eased = 1 - Math.pow(1 - t, 3);
            el.textContent = format.format(Math.round(target * eased));
            if (t < 1) requestAnimationFrame(tick);
          };
          el.textContent = format.format(0);
          requestAnimationFrame(tick);
        });
      }
    }
  );
}
